export class TicketOffer {
    id: string;
    minTripsCount: number;
    maxTripsCount: number;
    bonusTripsCount: number;
    discount: number;
    cost: number;
    price: number;
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/ticketOffer.ts